// extracted by mini-css-extract-plugin
export var cell = "_5a-4";
export var headerCell = "_5a-2";
export var rowHeader = "_5a-3";
export var table = "_5a-1";
export var tableContainer = "_5a-0";